import admin from './admin';
import user from './user';
import * as other from './other';

export default {
    admin,
    user,
    ...other,
};
